export default __webpack_public_path__ + "assets/4cf0b81f4669729f71201a2330c1bb8d/10.jpg";